export const cleanJsonString = (
  string: string,
  removeDoubleQuotes?: boolean
): string => {
  const cleaned = string.replace(/[\n\r\t]/g, '').replace(/\s{2,}/g, ' ');
  return removeDoubleQuotes ? cleaned.replace(/"/g, '') : cleaned;
};

export const normalizeString = (str: string): string =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const convertToString = (
  value: unknown,
  cleanJsonStringOption?: { clean: boolean; removeDoubleQuotes?: boolean }
): string => {
  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'bigint') {
    return value.toString();
  }

  if (typeof value === 'symbol') {
    return value.toString();
  }

  if (typeof value === 'undefined' || value === null) {
    return '';
  }

  if (typeof value === 'object') {
    try {
      const jsonString = JSON.stringify(value);
      const { clean, removeDoubleQuotes } = cleanJsonStringOption || {};
      return clean
        ? cleanJsonString(jsonString, !!removeDoubleQuotes)
        : jsonString;
    } catch (error) {
      return '';
    }
  }

  return String(value);
};
